import { useHistory } from 'react-router-dom';
import {
  MarketAccessory,
  MarketFooter,
  MarketHeader,
  MarketList,
  MarketRow,
} from '@market/react';
import { ReactComponent as MagnifyingGlass } from '@market/icons/assets/svg/magnifying-glass.svg';
import { ReactComponent as HumanArrowRight } from '@market/icons/assets/svg/human-arrow-right.svg';
import { ReactComponent as Scan } from '@market/icons/assets/svg/scan.svg';
import { useDispatch, useSelector } from 'react-redux';

import {
  RequestContext,
  customerSelector,
  customerContextSelector,
  getCustomer,
  getCustomerStateSelector,
} from 'store/customer';
import LoadingScreen from 'screens/Loading';
import { useEffect, useState } from 'react';
import { posContextSelector } from 'store/context';

const MainScreen = () => {
  const version = "7.13.0";
  const history = useHistory();
  const dispatch = useDispatch();

  const posContext = useSelector(posContextSelector);
  const addonName = posContext?.configurations?.addonName || 'LAVA';

  const customer = useSelector(customerSelector);
  const customerContext = useSelector(customerContextSelector);
  const getCustomerState = useSelector(getCustomerStateSelector);
  const [testingMode, setTestingMode] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    dispatch(getCustomer(RequestContext.SDK));
  }, [dispatch]);

  useEffect(() => {
    if (customerContext === RequestContext.SDK && customer) {
      history.push('/customer' + history.location.search);
    }
  }, [history, dispatch, customer, customerContext]);

  const isFetchingCustomer = () => {
    return (
      (!customerContext || customerContext === RequestContext.SDK) &&
      (getCustomerState.apiSuccess === undefined || getCustomerState.isPending)
    );
  };

  const handleClick = () => {
    setClickCount(prevClickCount => prevClickCount + 1);

    if (clickCount + 1 >= 10) {
      setTestingMode(!testingMode);
      setClickCount(0);
    }
  };

  if (isFetchingCustomer()) {
    // Display loading screen until customer has been fetched from SDK.
    return <LoadingScreen />;
  }

  return (
    <div className="market-grid-container" data-testid="main-screen">
      <MarketHeader className="market-grid-item-full" compact>
        <h2 onClick={handleClick}>Scan {addonName} Member Card</h2>
        {/*<p>*/}
        {/*  Select from the options below to add or enroll a Square Loyalty*/}
        {/*  customer.*/}
        {/*</p>*/}
      </MarketHeader>
      {testingMode ? (
      <MarketList
        className="market-grid-item-full"
        style={{ marginTop: '16px' }}
      >
        <MarketRow
          data-testid="search-customers-btn"
          onClick={() =>
            history.push('search-customers' + history.location.search)
          }
          variant="drill"
        >
          <MarketAccessory
            slot="leading-accessory"
            size="image"
            className="addons-market-row-leading-accessory"
          >
            <MagnifyingGlass
              className="addons-main-icon"
              width="24"
              height="24"
            />
          </MarketAccessory>
          <label slot="label">Search {addonName} Loyalty Members</label>
        </MarketRow>
      </MarketList>
      ) :  (
          <></>
      )}

      {posContext.device.hasScanner ? (
        <MarketFooter
          className="market-grid-item-full addons-footer-container"
          data-testid="main-footer"
        >
          <div className="addons-footer-content">
            <MarketAccessory size="icon">
              <Scan width="24" height="24" className="addons-scanner-icon" />
            </MarketAccessory>
            <label className="addons-scanner-main-text">
              Scanner activated
            </label>
          </div>
          <div className="addons-scanner-helper-text">
            Scan the customer's member pass to add them to the sale.
          </div>
        </MarketFooter>
      ) : (
        <></>
      )}
    <p style={{position: 'absolute', bottom: '5px', left: '10px'}}>Version: {version}</p>
    </div>
  );
};

export default MainScreen;
